var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMain = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20 1a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-5.347q-.014.018-.032.035l-1.914 1.915a1 1 0 0 1-1.414 0l-1.914-1.915L9.347 21H4a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm-8 10c-2.81 0-5.25 1.521-6.47 3.752-.324.591.154 1.248.827 1.248h11.286c.673 0 1.151-.657.828-1.248C17.25 12.522 14.81 11 12 11m0-7a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
})));
export default SvgMain;